import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "estate-listing__item"
}
const _hoisted_2 = { class: "estate-listing__item" }
const _hoisted_3 = { class: "estate-card__header" }
const _hoisted_4 = { class: "estate-card__photos" }
const _hoisted_5 = { class: "estate-card__info" }
const _hoisted_6 = {
  key: 0,
  class: "estate-card__logo mb-2"
}
const _hoisted_7 = { class: "estate-card__title has-actions" }
const _hoisted_8 = {
  key: 0,
  class: "actions"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icon-note" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "info-line-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "|", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "|", -1)
const _hoisted_15 = { class: "info-line-2" }
const _hoisted_16 = { class: "view-counter" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "|", -1)
const _hoisted_18 = {
  key: 0,
  class: "interested-counter"
}
const _hoisted_19 = {
  key: 0,
  class: "buttons"
}
const _hoisted_20 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_23 = { class: "check-label" }
const _hoisted_24 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_25 = ["checked"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_27 = {
  key: 2,
  class: "checkbox"
}
const _hoisted_28 = ["checked"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_31 = { class: "status" }
const _hoisted_32 = { class: "checkbox-switch" }
const _hoisted_33 = ["checked", "disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_35 = { class: "check-label" }
const _hoisted_36 = {
  key: 0,
  class: "flashmessage flash-warning"
}
const _hoisted_37 = {
  key: 0,
  class: "checkboxes"
}
const _hoisted_38 = { class: "checkbox" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_41 = { class: "checkbox" }
const _hoisted_42 = ["checked"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_44 = { class: "buttons" }
const _hoisted_45 = {
  key: 1,
  class: "estate-card__actions"
}
const _hoisted_46 = { class: "estate-card__footer" }
const _hoisted_47 = { class: "estate-card__params" }
const _hoisted_48 = {
  key: 1,
  class: "contact-person contact-person--inline"
}
const _hoisted_49 = { class: "contact-person__photo" }
const _hoisted_50 = { class: "contact-person__info" }
const _hoisted_51 = { class: "contact-person__name" }
const _hoisted_52 = {
  key: 0,
  class: "contact-person__logo"
}
const _hoisted_53 = {
  key: 0,
  class: "estate-card__note"
}
const _hoisted_54 = { class: "input-wrap" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "icon-note" }, null, -1)
const _hoisted_56 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_AdListGallery = _resolveComponent("AdListGallery")!
  const _component_AdLabels = _resolveComponent("AdLabels")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_AdListItemCompare = _resolveComponent("AdListItemCompare")!
  const _component_AdListItemLike = _resolveComponent("AdListItemLike")!
  const _component_AdListItemFavorite = _resolveComponent("AdListItemFavorite")!
  const _component_AdListItemPrice = _resolveComponent("AdListItemPrice")!
  const _component_AdParams = _resolveComponent("AdParams")!
  const _component_AdViewsStatistics = _resolveComponent("AdViewsStatistics")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isBannerVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Banner, { type: 2 })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["estate-card estate-card--offer", _ctx.classes])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AdListGallery, {
              images: _ctx.ad.images,
              estateType: _ctx.ad.estateType,
              estateSubType: _ctx.ad.estateSubType,
              adGuid: _ctx.ad.adGuid,
              width: 500,
              height: 420
            }, null, 8, ["images", "estateType", "estateSubType", "adGuid"]),
            _createVNode(_component_AdLabels, { ad: _ctx.ad }, null, 8, ["ad"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isDeveloperProject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_ResizableImage, {
                    url: _ctx.ad.developerProjectLogoRelativeUrl,
                    width: 209,
                    height: 80
                  }, null, 8, ["url"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.ad.title) + " ", 1),
              (!_ctx.isPublic && _ctx.isEstateAgent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["button button--icon", { 'is-active': _ctx.ad.internalNote }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleInternalNote())),
                      title: _ctx.$t('AdOfferListItem.button-internal-note-title')
                    }, _hoisted_11, 10, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(_ctx.address), 1),
              _hoisted_13,
              (_ctx.ad.publishDate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.publishDate')) + ": " + _toDisplayString(_ctx.$filters.date(_ctx.ad.publishDate)), 1),
                    _hoisted_14
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.lastChangedDate')) + ": " + _toDisplayString(_ctx.$filters.date(_ctx.ad.lastChangedDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.id')) + ": " + _toDisplayString(_ctx.ad.adFrontId), 1),
              (!_ctx.isPublic)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.viewCount', { viewCount: _ctx.ad.viewCount, lastWeekViewCount: _ctx.ad.lastWeekViewCount })) + " ", 1),
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('AdOfferListItem.viewCountPerWeek', { viewCount: _ctx.ad.viewCount, lastWeekViewCount: _ctx.ad.lastWeekViewCount })) + " ", 1),
                      _createElementVNode("a", {
                        class: "icon-chart",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showChartModal = true))
                      })
                    ]),
                    (!_ctx.isDeveloperProject)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('AdOfferListItem.interestedCount')) + " " + _toDisplayString(_ctx.ad.interestedCount), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["estate-card__toolbar", { 'has-multiple': !_ctx.isPublic }])
            }, [
              (_ctx.isPublic)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      class: "button button--primary",
                      tag: "button",
                      to: { name: 'AdDetail', params: { adFrontId: _ctx.ad.adFrontId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.button-detail')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.isMobile)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_multiselect, {
                            class: "multiselect-statuses w200",
                            modelValue: _ctx.publishStatus,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.publishStatus) = $event)),
                            options: _ctx.publishStatuses,
                            "show-labels": false,
                            searchable: false,
                            "allow-empty": false
                          }, {
                            singleLabel: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.status-change')), 1)
                            ]),
                            option: _withCtx(({ option }) => [
                              (option === 'publish')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_20, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isPublished) = $event)),
                                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                      disabled: !_ctx.isEmailConfirmed || _ctx.ad.isArchived
                                    }, null, 40, _hoisted_21), [
                                      [_vModelCheckbox, _ctx.isPublished]
                                    ]),
                                    _hoisted_22,
                                    _createElementVNode("span", _hoisted_23, [
                                      (_ctx.ad.isPublished)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.published')), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.unpublished')), 1)
                                          ], 64))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (option === 'reserve')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_24, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.reserved')), 1),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.ad.isReserved,
                                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onReservedChanged && _ctx.onReservedChanged(...args)))
                                    }, null, 40, _hoisted_25),
                                    _hoisted_26
                                  ]))
                                : _createCommentVNode("", true),
                              (option === 'archive')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_27, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.archived')), 1),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.ad.isArchived,
                                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                    }, null, 40, _hoisted_28),
                                    _hoisted_29
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"]),
                          _createElementVNode("div", null, [
                            (!_ctx.user.isEmailConfirmed)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$t('AdOfferListItem.email-not-confirmed')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.ad.isPublished,
                                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                disabled: !_ctx.isEmailConfirmed || _ctx.ad.isArchived
                              }, null, 40, _hoisted_33),
                              _hoisted_34,
                              _createElementVNode("span", _hoisted_35, [
                                (_ctx.ad.isPublished)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.published')), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.unpublished')), 1)
                                    ], 64))
                              ])
                            ]),
                            (!_ctx.user.isEmailConfirmed)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t('AdOfferListItem.email-not-confirmed')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.isDeveloperProject)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("label", _hoisted_38, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.reserved')), 1),
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.ad.isReserved,
                                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onReservedChanged && _ctx.onReservedChanged(...args)))
                                  }, null, 40, _hoisted_39),
                                  _hoisted_40
                                ]),
                                _createElementVNode("label", _hoisted_41, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdOfferListItem.archived')), 1),
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.ad.isArchived,
                                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                  }, null, 40, _hoisted_42),
                                  _hoisted_43
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64)),
                    _createElementVNode("div", _hoisted_44, [
                      (_ctx.isPublished)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "button button--primary reversed",
                            tag: "button",
                            to: { name: 'AdDetail', params: { adFrontId: _ctx.ad.adFrontId } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.button-show')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        class: "button button--primary",
                        tag: "button",
                        to: { name: _ctx.isDeveloperProject ? 'AdDeveloperProjectFormDetail' : 'AdFormEdit', params: { adFrontId: _ctx.ad.adFrontId } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdOfferListItem.button-edit')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ], 64))
            ], 2),
            (_ctx.isPublic)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_component_AdListItemCompare, { ad: _ctx.ad }, null, 8, ["ad"]),
                  _createVNode(_component_AdListItemLike, { ad: _ctx.ad }, null, 8, ["ad"]),
                  _createVNode(_component_AdListItemFavorite, { ad: _ctx.ad }, null, 8, ["ad"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          (!_ctx.isDeveloperProject)
            ? (_openBlock(), _createBlock(_component_AdListItemPrice, {
                key: 0,
                ad: _ctx.ad,
                showPriceSquare: true
              }, null, 8, ["ad"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_AdParams, { ad: _ctx.ad }, null, 8, ["ad"])
          ]),
          (_ctx.isEstateAgency)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ResizableImage, {
                        url: _ctx.ad.photoRelativeUrl,
                        onClick: _ctx.onAgentSelect,
                        placeholder: "img/no-photo-user.png",
                        width: 135,
                        height: 135,
                        alt: _ctx.ad.fullName
                      }, null, 8, ["url", "onClick", "alt"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.ad.fullName), 1),
                  (!_ctx.isEstateAgencyMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createVNode(_component_router_link, {
                          to: { name: 'AdAgencyList', params: { urlName: _ctx.ad.estateAgencyUrlName } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ResizableImage, {
                              classes: "estate-agency-logo",
                              url: _ctx.ad.logoRelativeUrl,
                              placeholder: "img/no-logo-agency.png",
                              width: 80,
                              height: 45,
                              onClick: _ctx.onAgencySelect
                            }, null, 8, ["url", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isPublic && _ctx.isEstateAgent && _ctx.isInternalNoteOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ad.internalNote) = $event)),
                  onKeydown: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isInternalNoteSaved = false)),
                  placeholder: _ctx.$t('AdOfferListItem.internal-note-placeholder')
                }, null, 40, _hoisted_56), [
                  [_vModelText, _ctx.ad.internalNote]
                ])
              ]),
              _createElementVNode("button", {
                class: "button button--link",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateInternalNote && _ctx.updateInternalNote(...args)))
              }, _toDisplayString(_ctx.$t(_ctx.isInternalNoteSaved ? 'AdOfferListItem.button-save-internal-note-saved' : 'AdOfferListItem.button-save-internal-note')), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_ctx.showChartModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#container"
        }, [
          _createVNode(_component_Modal, {
            title: _ctx.$t('AdViewsStatistics.title'),
            class: "modal-graph",
            onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showChartModal = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AdViewsStatistics, { ad: _ctx.ad }, null, 8, ["ad"])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}